import { useStore } from 'react-redux';
import { setPtoEntries } from '../redux/slices/ptoSlice';
import { setRecords } from '../redux/slices/protectedTimeSlice';
import useGuardedRealtimeList from './useGuardedRealtimeList';

// Containers own shared capacity data; child calendars read the same Redux state.
export default function useEngineeringCapacityRealtime({ pto = true, protectedTime = true } = {}) {
  const store = useStore();
  useGuardedRealtimeList({ apiKey: 'engineeringPto', enabled: pto, apply: data => store.dispatch(setPtoEntries(data)) });
  useGuardedRealtimeList({ apiKey: 'engineeringProtectedTime', enabled: protectedTime, apply: data => store.dispatch(setRecords(data)) });
}
